module.exports = __webpack_public_path__ + "static/img/26.199a439.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/26.jpg
// module id = TnP/
// module chunks = 1